import { render, staticRenderFns } from "./DynamicMails.vue?vue&type=template&id=bb846cd8&"
import script from "./DynamicMails.vue?vue&type=script&lang=ts&"
export * from "./DynamicMails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports